import { useRuntimeConfig } from 'virtual:runtime-config';

export const SKELETON_APPEARANCE_DELAY = 300;
export const SKELETON_MIN_VISIBLE_DURATION = 500;

export const MF_PREFIX = 'v2';

export const getMFName = (path: string): string => {
  const hasPrefix = path.includes(MF_PREFIX);

  return hasPrefix ? 'travelers-experience-guides-mfe-v2' : 'travelers-experience-guides-mfe';
};

export const MF_NAME = import.meta.env.VITE_RUNTIME_MF_NAME || 'travelers-experience-guides-mfe';

export const SENTRY_DSN = useRuntimeConfig()[MF_NAME].VITE_RUNTIME_SENTRY_DSN ?? '';

export const DESTINATION_GUIDES_REDESIGN_EXPERIMENT_SLUG = 'destinationGuides-redesign';
